<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
        <v-snackbar v-model="snackbar.show" top :color="snackbar.color">
			{{snackbar.message}}
			<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false">
				Close
			</v-btn>
		</v-snackbar>

		<v-card tile>
			<v-toolbar card dark color="primary">
				<v-btn icon dark @click.native="closeDialog()">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-items>
				</v-toolbar-items>
			</v-toolbar>
            
			<v-card-text>
                <loading-indicator 
				v-if="isLoading" 
				loading-text="Loading HR Document..." />

                <hr-document 
                    v-if="hrDocument"
                    :hr-document="hrDocument" 
                    :logged-in-tenant="loggedInTenant" 
                    :logged-in-employee="loggedInEmployee"
                    :is-admin="loggedInEmployee.isAdmin" 
                    :is-agreeing="isAgreeing" 
                    @onAgree="onAcknowledged"
                    @onUpdate="loadDocument" />
			</v-card-text>

			<div style="flex: 1 1 auto;"></div>
		</v-card>
	</v-dialog>
</template>

<script>
    import { mapGetters } from 'vuex';
	import HrDocument from '@/components/hrDocuments/HrDocument';
    import LoadingIndicator from '@/components/common/LoadingIndicator';

	export default {
		components: {
			HrDocument,
            LoadingIndicator
		},
		props: {
			id: {
				// HR Document Id
				required: true
			},
            dialog: {
                type: Boolean
            },
            title: {
                type: String,
                required: false
            }
		},
        data() {
            return {
                snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink'
				},
                isAgreeing: false,
				hrDocument: null,
				isLoading: false
            }
        },
        watch: {
            id: {
                immediate: true,
                handler() {
                    if (this.id) {
                        this.hrDocument = null;
                        this.loadDocument();
                    }
                }
            }
        },
        computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				loggedInTenant: 'loggedInTenant'
			})
		},
        methods: {
            showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : 'undefined';
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000
			},
            closeDialog() {
                this.$emit('closeDialog');
            },
            onAcknowledged(agreementData) {
				this.isAgreeing = true;

				const data = {
					id: this.hrDocument.id,
					employeeId: this.loggedInEmployee.id,
					acknowledgementTextOption: agreementData.acknowledgementTextOption,
					acknowledgementText: agreementData.acknowledgementText
				}

				this.$store.dispatch('hrDocuments/postAgreement', data).then(
				response => {
					this.$emit('onAcknowledged');
				},
				err => {
					this.isAgreeing = false;
					this.showSnackbar('An error has occurred', true);
				}
				);
			},
            loadDocument() {
				this.isLoading = true;
				return this.$store.dispatch('hrDocuments/getById', this.id).then(
					(hrDocument) => {
						this.isLoading = false;
						this.hrDocument = hrDocument;
					},
					(error) => {
						this.isLoading = false;
						this.showSnackbar('An error occurred loading document', true);
					}
				);
			},
        }
	};
</script>

<style></style>